export default __webpack_public_path__ + "static/2-739132ba374840236ed370011cf5d2b1.png";